import { render, staticRenderFns } from "./WinTheBid08.vue?vue&type=template&id=24862c4f&scoped=true&"
import script from "./WinTheBid08.vue?vue&type=script&lang=js&"
export * from "./WinTheBid08.vue?vue&type=script&lang=js&"
import style0 from "./WinTheBid08.vue?vue&type=style&index=0&id=24862c4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24862c4f",
  null
  
)

export default component.exports